import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  setPropTypes,
  lifecycle,
  branch,
  renderNothing,
  renderComponent,
} from 'recompose';
import { loadEmailConfirmationPageRequest } from './actions';
import Spinner from '../common/Spinner';
import EmailConfirmationSuccess from './EmailConfirmationSuccess';
import EmailConfirmationFailure from './EmailConfirmationFailure';
import styles from './EmailConfirmationPage.scss';

export default compose(
  setDisplayName('EmailConfirmationPage'),
  connect(
    (state) => {
      const { emailConfirmationPage: { error, loaded, fetching } } = state;
      return {
        error,
        loaded,
        fetching,
      };
    },
    { loadEmailConfirmationPageRequest },
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadEmailConfirmationPageRequest();
    },
  }),
  branch(
    ({ fetching }) => fetching,
    renderComponent(Spinner),
  ),
  branch(
    ({ fetching, loaded }) => !fetching && !loaded,
    renderNothing,
  ),
  branch(
    ({ error, loaded }) => error && loaded,
    renderComponent(() => (
      <div className={styles.root}>
        <EmailConfirmationFailure />
      </div>
    )),
  ),
  branch(
    ({ error, loaded }) => !error && loaded,
    renderComponent(() => (
      <div className={styles.root}>
        <EmailConfirmationSuccess />
      </div>
    )),
  ),
  setPropTypes({
    loadEmailConfirmationPageRequest: PropTypes.func.isRequired,
  }),
)(() => null);
